import styled from "styled-components";
import {ButtonPrimary} from "ui/base/Button/ButtonStyled";
import {StarFullIcon} from "ui/icons/StarFullIcon";
import {defaultThemeColors, fonts} from "ui/theme";
import {getAvatarUrl} from "utils";
import {UserIcon} from "../../../icons";

export const ProfileCard = ({userDetails, handleSendMessage}) => {
    return (
        <ProfileWrapper>
            <Profile>
                <Avatar>
                    {userDetails?.profile_pic ? (
                        <img
                            src={getAvatarUrl(userDetails?.profile_pic)}
                            alt={userDetails?.first_name}
                        />
                    ) : (
                        <UserIcon color="txt"/>
                    )}
                </Avatar>

                <ProfileInfo>
                    <Name>
                        {userDetails?.first_name} {userDetails?.last_name.charAt(0)}.
                    </Name>
                    <ReviewInfo>
                        <Rating>
                            <StarFullIcon size={20}/> &nbsp;
                            {userDetails?.student_rating_avg || 0}
                        </Rating>
                        &nbsp; (
                        {`${userDetails.user_reviews ? userDetails.user_reviews.length : 0} reviews`}
                        )
                    </ReviewInfo>
                    <ClassesInfo>{userDetails.classes_count} classes</ClassesInfo>
                </ProfileInfo>
            </Profile>
            <ButtonPrimary onClick={handleSendMessage} style={{
                width: "88%"
            }}>
                {/* <BubbleChat /> */}
                &nbsp;Message
            </ButtonPrimary>
        </ProfileWrapper>
    );
};

const ProfileWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 2rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background-color: rgba(167, 166, 206, 0.1);
    border-radius: 10px;

    @media (max-width: 1024px) {
        padding: 8px;
        height: auto;
        flex-direction: column;
        align-items: center;
    }
`;

const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    @media (max-width: 1024px) {
        text-align: left;
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        margin-left: 1rem;
    }
`;

const Profile = styled.div`
    flex-direction: column;
    align-items: center;
    display: flex;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: row;
        display: flex;
    }
`;

const Avatar = styled.div`
    width: 110px;
    height: 110px;
    background-color: ${defaultThemeColors.inputBgNeutral};
    border-radius: 130px;
    object-fit: cover;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;

    & > svg {
        height: 40px;
        width: 40px;
        opacity: 0.5;
    }

    & > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    @media (max-width: 1024px) {
        width: 60px;
        height: 60px;
    }
`;

const Name = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: bold;
    text-align: center;

    @media (max-width: 1024px) {
        text-align: left;
        font-size: ${fonts.sizes.medium};
    }
`;

const ReviewInfo = styled.div`
    display: flex;
    align-items: center;
    font-size: ${fonts.sizes.medium};
    color: #191d3a;
    font-weight: 600;
    @media (max-width: 1024px) {
        font-size: ${fonts.sizes.small};
    }
`;

const Rating = styled.span`
    display: flex;
    align-items: center;
    color: #ff827a;

    @media (max-width: 1024px) {
        text-align: left;
        font-size: ${fonts.sizes.small};
    }
`;

const ClassesInfo = styled.div`
    font-size: ${fonts.sizes.medium};
    color: #191d3a;
    margin-bottom: 20px;

    @media (max-width: 1024px) {
        text-align: left;
        font-size: ${fonts.sizes.small};
        margin-bottom: 0px;
    }
`;
